import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { APP_DRAWER_WIDTH } from 'constants/globals';
import classnames from 'classnames';

const paddingTop    = 10;
const paddingBottom = 10;
const paddingLeft   = 10;
const paddingRight  = 10;

const styles= theme => ({
  root: {
    height: 'calc(100vh - 70px)',
    minHeight: 'calc(100vh - 70px)',
    boxSizing: 'border-box',
    padding: [paddingTop, paddingBottom, paddingLeft, paddingRight],
    width: '100%',
    transition: theme.transitions.create('width'),
  },
  withMarginTop: {
    marginTop: '70px'
  },
  [theme.breakpoints.up('lg')]: {
    appBbodyShift: {
      width: `calc(100% - ${APP_DRAWER_WIDTH}px)`,
    },
  }
});

export class AppBody extends Component {
  render() {
    const { classes, children, disableAppDrawer } = this.props;
    const className = disableAppDrawer
      ? classes.root
      : classnames(classes.root, classes.withMarginTop, classes.appBbodyShift);

    return (
      <div className={className}>
        { children }
      </div>
    );
  }
}

AppBody.propTypes = {
  classes:      PropTypes.object.isRequired,
  disableAppDrawer: PropTypes.bool,
};

export default withStyles(styles)(AppBody);



// WEBPACK FOOTER //
// ./src/components/AppBody.js